import type { WriteOffMaterial } from '@shared/api';
import { fmtMoney, fmtNum } from '@shared/lib/smetaLabels';
import { Muted, Table } from '../styles';

export function MaterialsTable({
  items,
  kind,
}: {
  items: WriteOffMaterial[];
  kind: 'norm' | 'fact';
}) {
  if (items.length === 0) {
    return <Muted $mt={8}>Позиции не извлечены.</Muted>;
  }
  return (
    <Table>
      <thead>
        <tr>
          <th>Материал</th>
          <th>Ед.</th>
          <th className="num">Кол-во</th>
          <th className="num">Цена</th>
          <th className="num">Стоимость</th>
          <th>{kind === 'norm' ? 'Работа (КС-2)' : 'Документ'}</th>
        </tr>
      </thead>
      <tbody>
        {items.map((m) => (
          <tr key={m.id}>
            <td>
              {m.material_name}
              {m.material_code && <Muted>{m.material_code}</Muted>}
            </td>
            <td>{m.unit ?? '—'}</td>
            <td className="num">{fmtNum(m.quantity)}</td>
            <td className="num">{fmtMoney(m.unit_price)}</td>
            <td className="num">{fmtMoney(m.total_cost)}</td>
            <td>
              {kind === 'norm' ? (
                <Muted>{m.work_code ?? '—'}</Muted>
              ) : (
                <Muted>
                  {[m.document_no, m.supplier].filter(Boolean).join(' · ') || '—'}
                </Muted>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
